import { render, staticRenderFns } from "./ImgAvatar.vue?vue&type=template&id=7bbb74dc&"
import script from "./ImgAvatar.vue?vue&type=script&lang=ts&"
export * from "./ImgAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports